import {
  SourceDetails as EdgeSourceDetails,
  ListSourceDetailsQuery,
} from 'generated/graphql';
import { SourceDetail } from 'v2/core/entities/feedback/sources';
import { getSourceWithNamespaceFromEdgeSource } from '../sourceMapper';

const toSourceDetails = (source: EdgeSourceDetails): SourceDetail => ({
  name: getSourceWithNamespaceFromEdgeSource(source.id),
  eqlValue: source.eqlValue,
});

export const getSourceDetailsMapFromResponse = (
  data?: ListSourceDetailsQuery,
) => {
  return new Map(
    data?.listSourceDetails?.sources?.map((source) => {
      const detail = toSourceDetails(source);
      return [detail.name.name, detail];
    }),
  );
};
